// Copyright (c) Docugami, Inc. All rights reserved.

import styled from 'styled-components';
import { SmallContent } from 'components/common/Fonts';
import { DgButton } from 'components/common/DgCommonStyledComponents';
import { useNavigationService, NavigationType } from '../hooks/navigationService';

const Root = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    min-height: 500px;
    align-self: center;
    justify-self: center;
    width: 100%;
`;

const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
    align-items: center;
`;

const MessageContainer = styled.div`
    text-align: center;
    max-width: 600px;
`;

const RedirectButton = styled(DgButton)`
    width: fit-content;
    margin-top: 10px;
`;

const RedirectButtonContainer = styled.div`
    width: fit-content;
    margin-top: 10px;
    display: flex;
    gap: 20px;
`

export const UnsupportedPlatformPage = (): JSX.Element => {

    const navService = useNavigationService();

    return (
        <Root>
            <img src='assets/docugamiLogo-160.png' alt='Unsupported'/>
            <TextContainer>
                <MessageContainer>
                    <SmallContent>
                        It looks like you're accessing Docugami from an unsupported device or browser.
                        <br/>
                        <br/>
                        Docugami works best with desktop or laptop browsers, and is currently supported on Google Chrome and Microsoft Edge
                    </SmallContent>
                </MessageContainer>
                <RedirectButtonContainer>
                    <RedirectButton onClick={() => navService.navToHomePage(NavigationType.PushNewPage)}>Home</RedirectButton>
                    <RedirectButton onClick={() => navService.logout()}>Log out</RedirectButton>
                </RedirectButtonContainer>
            </TextContainer>
        </Root>
    )
}
